<template>
  <div>
    <b-modal v-model="modalVisible" v-if="mediaData" @close="modalVisible = false" size="lg" hide-header hide-footer hide-header-close>
      <img :src="mediaData" width="750" height="421" />
      <p />
      <base-button size="sm" type="danger" @click.native="downloadMediaBrowser(mediaObject)">
        Download
      </base-button>
      <base-button size="sm" type="danger" @click.native="deleteMedia()">
        Delete
      </base-button>
    </b-modal>
    <b-modal v-model="modalVisible" v-if="mediaVideo && mediaOptions" @close="modalVisible = false" size="lg" hide-header hide-footer hide-header-close>
      <video-player class="video-player-box" ref="videoPlayer" :options="mediaOptions" />
      <p />
      <base-button size="sm" type="danger" @click.native="downloadMediaBrowser(mediaObject)">
        Download
      </base-button>
      <base-button size="sm" type="danger" @click.native="deleteMedia()">
        Delete
      </base-button>
    </b-modal>
    <b-tabs pills v-model="tabIndex">
      <b-tab key="Media" title="Media">
        <p/>
        <b-card no-body>
          <b-card-body>
            <b-container fluid="xl">
              <div style="display: flex;">
                <div style="flex: 1.5;">
                  <base-button size="sm" type="neutral" @click.native="refreshData" style="float: right;">Refresh</base-button>
                </div>
              </div>
              <time-line type="one-side" v-if="this.media && this.media.length > 0">
                <time-line-item v-for="(r, rIdx) in this.media"
                                v-bind:key="r.id"
                                :badge-type="getBadgeType(r.transferReason)"
                                :badge-icon="getBadgeIcon(r.transferReason)">

                  <div>
                    {{ $formatDate(new Date(r.timestamp)) }}
                  </div>
                  <div>
                    <h3>{{ $formatTime(new Date(r.timestamp)) }}</h3>
                  </div>
                  <div v-if="r.transferReason">
                    <h2>{{ r.transferReason }}</h2>
                  </div>
                  <b-row>
                    <b-col v-for="(m, mIdx) in r.media" cols="3">
                      <h3>{{ $getCameraName(m.camera) }} {{ m.mimeType === "image/jpeg" ? "picture" : "video" }}</h3>
                      <div>
                        <img :src="m['data']" @click="openMedia(m, m['data'])" width="250" height="140" />
                      </div>
                    </b-col>
                  </b-row>
                </time-line-item>
              </time-line>
            </b-container>
          </b-card-body>
        </b-card>
      </b-tab>
      <b-tab key="Requests" title="Requests" lazy>
        <p/>
        <b-row>
          <b-col cols="12">
            <b-card no-body v-if="createMediaRequest">
              <b-card-header>
                <h5 class="h3 mb-0">Create media request</h5>
              </b-card-header>
              <b-card-body>
                <validation-observer v-slot="{ invalid, validate, pristine }" ref="mediaRequestFormValidator">
                <b-form @submit.prevent="handleSaveMediaRequest">
                  <b-container fluid="xl">
                    <b-row>
                      <b-col cols="3">
                        <div>
                          <base-input label="Media type">
                            <el-select width="120"
                                       filterable
                                       placeholder="Media type"
                                       v-model="mediaRequest.mediaType"
                                       :required=true>
                              <el-option key="PICTURE" label="Picture" value="PICTURE" />
                              <el-option key="VIDEO" label="Video" value="VIDEO" />
                            </el-select>
                          </base-input>
                        </div>
                        <div>
                          <ValidationProvider v-if="mediaRequest.mediaType === 'VIDEO'" rules="duration" v-slot="{ errors, validate, pristine }" immediate>
                            <base-input name="Duration" type="number" label="Duration (s)" v-model.number="mediaRequest.duration" v-if="mediaRequest.mediaType === 'VIDEO'" :required=true />
                            <p class="error">{{ errors[0] }}</p>
                          </ValidationProvider>
                        </div>
                      </b-col>
                      <b-col cols="3">
                        <div>
                          <base-input label="Date" type="date" v-model="form.startDate" :required=true />
                        </div>
                        <div>
                          <base-input label="Time" type="time" v-model="form.startTime" :required=true />
                        </div>
                      </b-col>
                      <b-col cols="3">
                        <div>
                          <base-input label="Camera front">
                            <b-form-checkbox class="mb-3" v-model="form.cameraFront" @change="updateFormCameraMask" />
                          </base-input>
                          <base-input label="Camera rear">
                            <b-form-checkbox class="mb-3" v-model="form.cameraRear" @change="updateFormCameraMask" />
                          </base-input>
                        </div>
                      </b-col>
                      <b-col cols="3">
                        <div>
                          <base-input label="Camera left">
                            <b-form-checkbox class="mb-3" v-model="form.cameraLeft" @change="updateFormCameraMask" />
                          </base-input>
                          <base-input label="Camera right">
                            <b-form-checkbox class="mb-3" v-model="form.cameraRight" @change="updateFormCameraMask" />
                          </base-input>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="6">
                        <div>
                          <ValidationProvider
                            ref="cameraSelectedProvider"
                            rules="cameraSelected"
                            vid="cameraSelected"
                            v-slot="{ errors, validate, pristine }"
                          >
                            <base-input :hidden="true" v-model="mediaRequest.cameraMask" />
                            <p class="error">{{ errors[0] }}</p>
                          </ValidationProvider>
                          <p/>
                          <base-button size="sm" type="neutral" native-type="submit" @click.native="handleSaveMediaRequest" :disabled="invalid || pristine">Save</base-button>
                          <base-button size="sm" type="neutral" @click.native="handleCancelMediaRequest">Cancel</base-button>
                        </div>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-form>
                </validation-observer>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <b-card no-body>
          <b-card-body>
            <b-container fluid="xl">
              <div style="display: flex;">
                <div style="flex: 1.5;">
                  <base-button size="sm" type="neutral" @click.native="refreshData" style="float: right;">Refresh</base-button>
                  <base-button size="sm" type="neutral" @click.native="handleCreateMediaRequest" style="float: right;">Create media request</base-button>
                </div>
              </div>
              <time-line type="one-side" v-if="this.mediaRequests && this.mediaRequests.length > 0">
                <time-line-item v-for="(r, rIdx) in this.mediaRequests"
                                badge-type="info"
                                badge-icon="ni ni-bell-55">

                  <div>
                    {{ $formatDate(new Date(r.timestamp)) }}
                  </div>
                  <div>
                    <h3>{{ $formatTime(new Date(r.timestamp)) }}</h3>
                  </div>
                  <div>
                    <b>Request details</b>
                  </div>
                  <div>
                    Requested date/time : {{ $formatDate(new Date(r.mediaTimestamp)) }} {{ $formatTime(new Date(r.mediaTimestamp)) }}
                  </div>
                  <div>
                    Requested : {{ r.mediaType }}
                  </div>
                  <div v-if="r.mediaType === 'VIDEO'">
                    Duration : {{ r.duration }}
                  </div>
                  <div>
                    Cameras : {{ $getCamerasFromMask(r.cameraMask) }}
                  </div>
                  <div>
                    Synced with device : {{ r.syncedWithDevice !== undefined }}
                  </div>
                  <p/>

                  <base-button size="sm" type="primary" class="m-1" v-if="r.syncedWithDevice !== undefined" v-b-toggle="'availability-'+r.timestamp" @click.native="getMediaRequestMedias(r)">Availability</base-button>

                  <b-collapse :id="'availability-'+r.timestamp">
                    <p/>
                    <div v-for="(m) in r.medias" v-if="r.medias" v-bind:key="m.id">
                      &nbsp;&nbsp;&nbsp;{{ $getCameraName(m.camera) }} : {{ m.availability }}
                    </div>
                    <p/>
                    &nbsp;&nbsp;&nbsp;<base-button size="sm" type="primary" class="m-1" @click.native="getMediaRequestMedias(r)">Refresh</base-button>
                  </b-collapse>
                </time-line-item>
              </time-line>
            </b-container>
          </b-card-body>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import crudApi from "../../crud/crud-api";
import { TimeLine, TimeLineItem } from '@/components';
import Badge from '@/components/Badge';
import {Option, Select} from "element-ui";
import {formatTime} from "../../util/formatting";
import { ValidationObserver } from 'vee-validate';
import { ValidationProvider, extend } from 'vee-validate';

extend('cameraSelected', {
  validate (value) {
    return Number(value) > 0
  },
  message: 'At least one camera must be selected.'
})
extend('duration', {
  validate (value) {
    return Number(value) >= 1 && Number(value) <= 300
  },
  message: 'The duration must be between 1 and 300 seconds (5 minutes).'
})

export default {
  components: {
    Badge,
    TimeLine,
    TimeLineItem,
    [Select.name]: Select,
    [Option.name]: Option,
    ValidationObserver,
    ValidationProvider
  },
  name: "entity-media",
  props: {
    type: {
      type: String,
      default: 'ASSET',
      description: "Types : ASSET, DRIVER"
    },
    entityId: {
      type: String,
      required: true,
      description: "Entity ID"
    },
  },
  created() {
    this.getEntityMedia()
  },
  data: _ => ({
    tabIndex: 0,
    media: undefined,
    createMediaRequest: false,
    mediaRequest: undefined,
    mediaRequests: undefined,
    form: undefined,
    mediaObject: undefined,
    mediaData: undefined,
    mediaVideo: undefined,
    mediaOptions: undefined,
    downloadMediaId: undefined,
    modalVisible: false,
    videoOptions: { height: 140, playbackRates: [0.3, 0.5, 0.7, 1.0, 1.5, 2.0] }
  }),
  watch: {
    '$store.state.filter.period': function () {
      this.refreshData()
    },
    '$store.state.filter.from': function () {
      this.refreshData()
    },
    '$store.state.filter.until': function () {
      this.refreshData()
    },
    '$store.state.filter.group': function () {
      this.refreshData()
    },
    'tabIndex': function () {
      console.log('tabIndex is now => ' + this.tabIndex)

      this.refreshData()
    },
  },
  methods: {
    refreshData() {
      if (this.tabIndex === 0) {
        this.getEntityMedia()
      }
      if (this.tabIndex === 1) {
        this.getEntityMediaRequests()
      }
    },
    getEntityMedia() {
      this.media = undefined

      let fromTime = undefined
      if (this.$store.state.filter.from) {
        fromTime = new Date(this.$store.state.filter.from)
      }

      let untilTime = undefined
      if (this.$store.state.filter.until) {
        untilTime = new Date(this.$store.state.filter.until)
      }

      let id = this.entityId

      if (this.type === 'ASSET') {
        crudApi.getAssetMedia(id, fromTime, untilTime).then(json => this.media = this.processMedia(json.data ? json.data.slice().reverse() : json))
      } else {
        crudApi.getDriverMedia(id, fromTime, untilTime).then(json => this.media = this.processMedia(json.data ? json.data.slice().reverse() : json))
      }
    },
    getEntityMediaRequests() {
      this.mediaRequests = undefined

      let fromTime = undefined
      if (this.$store.state.filter.from) {
        fromTime = new Date(this.$store.state.filter.from)
      }

      let untilTime = undefined
      if (this.$store.state.filter.until) {
        untilTime = new Date(this.$store.state.filter.until)
      }

      let id = this.entityId

      if (this.type === 'ASSET') {
        crudApi.getAssetMediaRequests(id, fromTime, untilTime).then(json => this.mediaRequests = this.processMediaRequests(json.data ? json.data.slice().reverse() : json))
      } else {
        crudApi.getDriverMediaRequests(id, fromTime, untilTime).then(json => this.mediaRequests = this.processMediaRequests(json.data ? json.data.slice().reverse() : json))
      }
    },
    getMediaRequestMedias(mediaRequest) {
      mediaRequest.medias = []

      crudApi.getMediaRequestMedias(mediaRequest.id).then(json => mediaRequest.medias = (json.data ? json.data : json))
    },
    processMediaRequests(mediaRequestArray) {
      let result = []

      for (let mediaRequest of mediaRequestArray) {
        mediaRequest.medias = []

        result.push(mediaRequest)
      }

      return result
    },
    processMedia(mediaArray) {
      let result = []

      let lastTime = undefined
      let transferReason = undefined
      let medias = []
      for (let media of mediaArray) {
        if (!media.fileName) continue

        if (lastTime && lastTime !== media.timestamp) {
          result.push({ "timestamp": lastTime, "media": medias, "transferReason": transferReason})

          medias = []
          transferReason = undefined
        }

        media['data'] = undefined

        this.downloadMediaThumbnail(media)

        medias.push(media)

        lastTime = media.timestamp
        if (media.transferReason) {
          transferReason = media.transferReason
        }
      }
      if (lastTime) {
        result.push({ "timestamp": lastTime, "media": medias, "transferReason": transferReason})
      }

      return result
    },
    downloadMedia(media) {
      if (media.mimeType !== "video/mp4") {
        crudApi.downloadMedia(media.id).then(res => media['data'] = URL.createObjectURL(new Blob([res.data])))
      }

      return true
    },
    downloadMediaThumbnail(media) {
      crudApi.downloadMediaThumbnail(media.id).then(res => media['data'] = URL.createObjectURL(new Blob([res.data])))

      return true
    },
    openMedia(media, data) {
      this.mediaObject = media
      this.mediaData = undefined
      this.mediaVideo = undefined
      this.modalVisible = true
      this.downloadMediaId = media.id

      if (media.mimeType === "video/mp4") {
        console.log("open video")

        crudApi.downloadMedia(this.downloadMediaId).then(res => {
          this.mediaVideo = URL.createObjectURL(new Blob([res.data]))
          this.mediaOptions = { height: 421, playbackRates: [0.7, 1.0, 1.5, 2.0], sources: [{ type: "video/mp4", src: this.mediaVideo }] }
        })
      } else {
        console.log("open picture")

        crudApi.downloadMedia(media.id).then(res => this.mediaData = URL.createObjectURL(new Blob([res.data])))
      }
    },
    downloadMediaBrowser(media) {
      crudApi.downloadMedia(this.downloadMediaId).then(res => {
        let url = window.URL.createObjectURL(new Blob([res.data]));
        let link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', media.fileName);
        document.body.appendChild(link);
        link.click();
      });
    },
    handleCreateMediaRequest() {
      this.mediaRequest = {
        "assetId": this.entityId,
        "mediaType": "PICTURE",
        "duration": 0,
        "cameraMask": 0,
      }

      let now = new Date()

      this.form = {
        "cameraFront": false,
        "cameraRear": false,
        "cameraLeft": false,
        "cameraRight": false,
        "cameraDriver": false,
        "startDate": now.toISOString().slice(0,10),
        "startTime": formatTime(now)
      }

      this.createMediaRequest = true

      this.$nextTick(() => {
        if (this.$refs.mediaRequestFormValidator) {
          this.$refs.mediaRequestFormValidator.validate()
        }
      })
    },
    async handleSaveMediaRequest() {
      let ok = await this.$refs.mediaRequestFormValidator.validate()
      if (!ok) return

      this.mediaRequest.timestamp = new Date()
      this.mediaRequest.mediaTimestamp = new Date(Date.parse(this.form.startDate + "T" + this.form.startTime))
      this.mediaRequest.cameraMask = this.getFormCameraMask()

      if (this.type === 'ASSET') {
        crudApi.createAssetMediaRequest(this.entityId, this.mediaRequest)
      } else {
        crudApi.createDriverMediaRequest(this.entityId, this.mediaRequest)
      }

      this.mediaRequest = undefined
      this.createMediaRequest = false
    },
    handleCancelMediaRequest() {
      this.mediaRequest = undefined
      this.createMediaRequest = false
    },
    updateFormCameraMask() {
      this.mediaRequest.cameraMask = this.getFormCameraMask()

      this.$refs.cameraSelectedProvider.validate(this.mediaRequest.cameraMask)
    },
    getFormCameraMask() {
      let mask = 0;

      if (this.form.cameraFront) {
        mask = mask | 1;
      }
      if (this.form.cameraRear) {
        mask = mask | 2;
      }
      if (this.form.cameraLeft) {
        mask = mask | 4;
      }
      if (this.form.cameraRight) {
        mask = mask | 8;
      }
      if (this.form.cameraDriver) {
        mask = mask | 16;
      }

      return mask;
    },
    getBadgeType(transferReason) {
      switch(transferReason) {
        case "REQUESTED":
          return "info"
        case "OVER_SPEED_START":
          return "success"
        case "OVER_RPM_START":
          return "success"
        case "HARSH_ACCELERATION":
          return "danger"
        case "HARSH_BRAKE":
          return "danger"
        default:
          return "info"
      }
    },
    getBadgeIcon(transferReason) {
      return "ni ni-bell-55"
    },
  }
}
</script>

<style scoped>

</style>
